<div class="main_content px-3 position-relative">

    <div class="container-fluid py-3">
        <div class="title mb-4">
            <h3>Activity Log</h3>
        </div>
        <!-- <div class="my-2">
            <button class="btn btn-success" (click)="openModal(UploadFileModal)">
                <i class="fa-solid fa-plus"></i> Add Cashback
            </button>
        </div> -->

        <div class="row">
            <div class="col-lg-12 col-md-12 ">
                <div class="white_box shadow p-3">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Type</th>
                                <th scope="col">Message</th>
                                <th scope="col">Created At</th>
                                <!-- <th scope="col">Action</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of activityLog.data; let i = index;">
                                <th scope="row">{{i + 1}}</th>
                                <td>{{item.type}}</td>
                                <td>{{item.message}}</td>
                                <td>{{item.createdAt | date:'dd-MM-yyyy'}}</td>
                                <!-- <td>
                                    <div class="btn-group" role="group" aria-label="Action buttons">
                                        <button type="button" class="btn btn-danger" (click)="handleDelete(item.id)">
                                            <i class="fa-solid fa-trash"></i>
                                        </button>
                                        <button type="button" class="btn btn-secondary"
                                            (click)="handleView(item.id); modalService.open(ViewDetailModal)">
                                            <i class="fa-solid fa-list"></i>
                                        </button>
                                    </div>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                    <nav aria-label="Page navigation example">
                        <ul class="pagination">
                            <li class="page-item" [class.disabled]="activityLog.currentPage === 1">
                                <a class="page-link" (click)="initData(activityLog.currentPage - 1)" aria-label="Previous">
                                    <span aria-hidden="true">&laquo;</span>
                                </a>
                            </li>
                            <li class="page-item" *ngFor="let page of [].constructor(activityLog.totalPages); let i = index" [class.active]="activityLog.currentPage === i + 1">
                                <a class="page-link" (click)="initData(i + 1)">{{ i + 1 }}</a>
                            </li>
                            <li class="page-item" [class.disabled]="activityLog.currentPage === activityLog.totalPages">
                                <a class="page-link" (click)="initData(activityLog.currentPage + 1)" aria-label="Next">
                                    <span aria-hidden="true">&raquo;</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</div>
